import { AppState } from 'common/appState';

export const getCheckEvidences = (state: AppState) => state.check.checkEvidences;
export const getCheckActiveBenefits = (state: AppState) => state.check.checkActiveBenefits;
export const getCheckScores = (state: AppState) => state.check.checkScores;
